import { Send } from '@mui/icons-material';
import {Box, styled, TextField} from '@mui/material';
import React, { useEffect } from 'react';
import SubmitDataService from '../../services/SubmitDataService';
import HintHelper from "../HintHelper/HintHelper";
import swal from "sweetalert2";
import {useDataFormFields} from "../../hooks/useDataFormFields";

const UsageDataForm = () => {
  const [formData, setFormData, usageField] = useDataFormFields()

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await SubmitDataService.getUsageData();
        setFormData(data);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    }
    fetchData();
  }, [setFormData]);

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const numString = value.toString().replace(/\./g, '');
    return numString.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const parseNumber = (formattedValue) => {
    if (formattedValue === '') return null;
    const numberString = formattedValue.replace(/\./g, '');
    return isNaN(numberString) ? null : parseInt(numberString, 10);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    const filteredValue = value.replace(/[^\d]/g, '');
    const parsedValue = parseNumber(filteredValue);

    setFormData(prevData => ({
      ...prevData,
      [id]: parsedValue
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const hasZero = Object.entries(formData).some(([key, value]) =>  key !== 'totalBeneficiarios' && value === 0)
    if (hasZero){
      return swal.fire({
        title: 'Campo inválido',
        text: 'Um dos campos foi preenchido com zero, insira um número maior que zero.',
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: '#368C5D'
      })
    }
    try {
      SubmitDataService.submitUsageData(formData);
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
    }
  };

  return (
    <form className="w-full h-full bg-white shadow-md flex flex-col items-center mt-5"
          onSubmit={handleSubmit}
    >
      <div className='w-full'>
        <h1 className='text-2xl text-center py-5'>Dados de utilização da operadora</h1>
      </div>
      <div className='w-full md:px-[20%] px-2 flex flex-col gap-y-6 md:pb-8 pt-4 overflow-y-scroll'>
        {Array.isArray(usageField) && usageField.map((item, index) => (
          <Box sx={{display: "flex", alignItems: 'flex-end', width: '100%', position: 'relative'}} key={item.id}>
            <StyledTextField required value={formatNumber(item.value)} onChange={handleChange} sx={{width: '100%'}} inputProps={{ min: 0 }} type="text" id={item.id} label={item.label} variant="outlined" />
            <HintHelper message={item.hint()} className="right-0 top-4 mr-10"  messageStyle={"md:w-96 w-64 " +
              ((index === usageField.length - 1 || index === usageField.length - 2)
                ? "-top-20 right-5"
                : "top-6 right-5")
            }/>
          </Box>
        ))}

        <div className='flex items-center justify-center'>
          <button
            className="text-white bg-emerald-800  py-2 rounded-lg hover:bg-emerald-900 w-full md:w-1/2 text-center"
            type='submit'
          >
            <Send className='mr-2' />
            Salvar
          </button>
        </div>
      </div>
    </form>
  );
};

const StyledTextField = styled(TextField)({
  '& label': {
    fontFamily: 'Inter',
    fontSize: '.9rem',
    color: 'gray',
  },
  '& label.Mui-focused, & label.MuiFormLabel-filled': {
    fontFamily: 'Inter',
    fontSize: '1.2rem',
    color: '#000',
  },
  '& label.MuiFormLabel-filled': {
    fontFamily: 'Inter',
    color: 'gray',
  },
  '& label.Mui-focused': {
    fontFamily: 'Inter',
    color: '#000',
  },
  '& .MuiInputBase-root': {
    fontFamily: 'Inter',
    fontSize: '1.2rem',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'gray',
    },
    '&:hover fieldset': {
      borderColor: 'black',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'black',
    },
  },
});

export default UsageDataForm;
export { StyledTextField };
